import { render, staticRenderFns } from "./companyTimeoffSetup.vue?vue&type=template&id=b25af1e0"
import script from "./companyTimeoffSetup.vue?vue&type=script&lang=js"
export * from "./companyTimeoffSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports